// extracted by mini-css-extract-plugin
export default {"overlay":"DormModals_overlay__7k20d","modal":"DormModals_modal__YMspF","field":"DormModals_field__8mp7N","actions":"DormModals_actions__mL4lk"};